export const topBarHeight = 64;
export const sideNavWidth = 240;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;
export const EMPTY_NULL_DATA = '--';
export const CUSTOMER_COLOR = 'blue';
export const SERVICE_PROVIDER_COLOR = 'green';
